import { render, staticRenderFns } from "./ServerDialog.vue?vue&type=template&id=245e232a&"
import script from "./ServerDialog.vue?vue&type=script&lang=js&"
export * from "./ServerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports